export enum Grapes {
  White = 'white',
  Red = 'red',
  Rose = 'rose',
  Sparkling = 'sparkling',
  BlancDeNoir = 'blancdenoir',
  Other = 'other',
  NotSet = 'not_set',
}
